module.exports = __webpack_public_path__ + "static/media/spence-gray.1f5e0b54.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spence-gray.svg
// module id = 2440
// module chunks = 0